export enum QuestionaryType {
  PROFESSIONAL = 'professional',
  PSYCHOLOGICAL = 'psychological',
  SATISFACTION = 'satisfaction',
  SELF_CONTROL = 'self-control'
}
